import './App.css';
import DashboardComponent from './components/dashboard/dashboard';
import LoginComponent from './components/login/Login';
import ErrorComponent from './components/error/error';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import AuthProvider, { useAuth } from './components/http/authcontex';
import ShowProject from './components/project/project';
import ProjectForm from './components/project/addproject'; // Make sure this is the unified form component
import Report from './components/report/report';
import AddCVs from './components/cvs/addcvs';
import ShowCVs from './components/cvs/cvs';
import PublicShowCVs from './components/cvs/cvspublic';


function RoutAuth({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/" />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<LoginComponent />} />
            <Route path="/dashboard" element={
              <RoutAuth>
                <DashboardComponent />
              </RoutAuth>
            } />
            
            <Route path="/project" element={
              <RoutAuth>
                <ShowProject />
              </RoutAuth>
            } />
            
            {/* Add route for editing with ID parameter */}
            <Route path="/editproject/:id" element={
              <RoutAuth>
                <ProjectForm />
              </RoutAuth>
            } />
            
            <Route path="/addproject" element={
              <RoutAuth>
                <ProjectForm />
              </RoutAuth>
            } />
            
            <Route path="/report" element={
              <RoutAuth>
                <Report />
              </RoutAuth>
            } />
            {/* Route for displaying the list of CVs */}
            <Route path="/cvs" element={
              <RoutAuth>
                <ShowCVs />
              </RoutAuth>
            } />

            {/* Route for adding a new CV */}
            <Route path="/add-cv" element={
              <RoutAuth>
                <AddCVs />
              </RoutAuth>
            } />

            {/* Route for editing an existing CV (reusing AddCVs component) */}
            {/* The :id parameter will be used by AddCVs to fetch data for editing */}
            <Route path="/add-cv/:id" element={
              <RoutAuth>
                <AddCVs />
              </RoutAuth>
            } />

            <Route path="/public-cvs/:id" element={<PublicShowCVs />}/>
            
            <Route path="*" element={<ErrorComponent />} />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;